import { CartLineItem } from './cartDomain';
import {
  JobFullfillmentShippingInfoInternalDistribution,
  JobGenerateTypeEnum,
  ShippingAccountTypeEnum,
} from './jobconfigDomain';
import { BalanceSelectPaymentMethodsEnum } from './orgDomain';
import { CarrierTypeEnum } from './shippingDomain';
import { JobTypeEnum } from './workspaceDomain';

export type PriceLineItem = {
  type: string;
  price: number;
};
export interface ShippingLineItem {
  quantity: number;
  total: number;
  address: {
    toAddressLine: '4435 E Chandler Blvd Suite 202';
    toCity: 'Phoenix';
    toCountryCode: 'US';
    toName: 'Vincent Zicchinolfi';
    toPostalCode: '85048';
    toStateProvinceCode: 'AZ';
  };
  shippingMethod: {
    title: string;
    estimatedArrivalDate: string;
  };
  priceLineItems: PriceLineItem[];
}

export interface OrderLineItem {
  id: string;
  name: string;
  quantity: number;
  total: number;
  shippingLineItems: ShippingLineItem[];
}

export interface OrderItem {
  orderTotal: number;
  orderLineItems: OrderLineItem[];
  id: string;
}

export enum OrderStatusEnum {
  AWAITING_PAYMENT = 'AWAITING_PAYMENT',
  PAYMENT_PROCESSING = 'PAYMENT_PROCESSING',
  MARKED_AS_PAID = 'MARKED_AS_PAID',
  PAYMENT_RECEIVED = 'PAYMENT_RECEIVED',
  CANCELLED = 'CANCELLED',
}

export type OrderHistoryItem = {
  id: string;
  status: OrderStatusEnum;
  orderPayments: OrderPayment[];
  jobs: CartLineItem[];
  billingInfo: BillingInfo;
  billingRequestor: BillingRequestor;
  createAt: string;
  updateAt: string;
  freightCharge: number;
  printingCharge: number;
  taxCharge: number;
  totalCharge: number;
};

export type PaylodPlaceOrder = {
  lineItems: string[];
};

export type PaymentApiPayload = {
  // gatewayType: {
  //   type: string | 'Stripe';
  // };
  // orderCurrencyCode: string;
  orderId: string;
  orgId?: number;
  // orderTotal: number;
};

export type PaymentApiPayloadRes = {
  details: {
    clientSecret: string;
    providerPaymentReference: string;
  };
  orderId: string;
  total: number;
};

export enum ShipmentTypeEnum {
  PACKAGE = 'PACKAGE',
  FREIGHT = 'FREIGHT',
}

export type PurchaseOrderJobShippingItemCarrierOptions = {
  carrierType: CarrierTypeEnum;
  serviceName: string;
  estimatedDeliveryTime: string;
  estimateShipTime: string;
  shipmentType: ShipmentTypeEnum;
  accountType: ShippingAccountTypeEnum;
  /** what the carrier charges for this service, the cost the freight markup runs on */
  charge?: number;
  /** what the buyer pays for this service, cost plus the job's freight markup */
  freightCharge?: number;
  freeShipping?: boolean;
};

export type PurchaseOrderJobShippingItemAccountTypeOptions = {
  accountType: ShippingAccountTypeEnum;
  company: string;
  orgId: number;
  orgName: string;
  carrierTypes: CarrierTypeEnum[];
};

export type PurchaseOrderJobShippingItemCarrier = {
  carrierService: string;
  carrierOptions: PurchaseOrderJobShippingItemCarrierOptions[];
  carrierType: CarrierTypeEnum;
  accountType: ShippingAccountTypeEnum;
  accountTypeOptions: PurchaseOrderJobShippingItemAccountTypeOptions[];
  shipmentType: ShipmentTypeEnum;
  estimatedDeliveryTime: string;
  expectedDeliveryDate?: string;
};

export type PurchaseOrderJobShippingItem = {
  carrier?: PurchaseOrderJobShippingItemCarrier;
  readyDate?: string;
  carrierService: string;
  carrierType: CarrierTypeEnum;
  name: string;
  quantity: number | undefined;
  serialNumber?: number;
  shipmentType: ShipmentTypeEnum;
  weight: number;
  expectedDeliveryDate?: any;
  jobId?: number;
  key?: string;
  costLineItems: {
    freightCharge: number;
    printingCharge: number;
    totalCharge: number;
    revxFreightCharge: number;
    shippingCost: number;
    revxPrintingCharge: number;
    revxTotalCharge: number;
  };

  shippingInfo: {
    estimatedDeliveryTime?: string;
    estimatedShipTime?: string;
    phoneNumber?: string;
    toAddressLine: string;
    toCity: string;
    toCompany?: string;
    toCountryCode: string;
    toName: string;
    toPostalCode: string;
    toStateProvinceCode: string;
    internalDistribution?: JobFullfillmentShippingInfoInternalDistribution;
  };
  internalDistribution?: JobFullfillmentShippingInfoInternalDistribution;
};

export type PurchaseWrapper = {
  jobs: PurchaseOrderJob[];
  billingInfo: BillingInfo;
  billingRequestor: BillingRequestor;
  billingToInfo?: BillingToInfo;
};

export type PurchaseOrderJob = {
  jobId: number;
  jobName: string;
  skuName: string;
  jobType: JobTypeEnum;
  shippingItems: PurchaseOrderJobShippingItem[];
  jobGenerateType: JobGenerateTypeEnum;
  directlyAddToCart: boolean;
  taxCharge: number;
  weightUnit: number;
  quantity?: number;
  freightCharge?: number;
  printingCharge?: number;
  totalCharge?: number;
  hideFreightCost?: boolean;
  orderDate?: string;
  internalDistributionEnabled?: boolean;
};

export type PurchaseOrder = {
  billingInfo: BillingInfo | undefined;
  billingRequestor: BillingRequestor | undefined;
  billingToInfo?: BillingToInfo;
  requestor: ContactInfo | undefined;
  billingTo: ContactInfo | undefined;
  id: string | undefined;
  userId: number;
  orgId: number;
  remark: string;
  status: OrderStatusEnum | undefined;
  printingCharge: number;
  freightCharge: number;
  taxCharge: number;
  totalCharge: number;
  jobs: PurchaseOrderJob[];
  jobIds?: number[];
  paymentMethod?: BalanceSelectPaymentMethodsEnum | undefined;
  costDistribution?: CostDistributionPayload;
  /** Canva JIT: sent on first checkout to replace synthetic user profile (see job-api checkout). */
  checkoutLegalFirstName?: string;
  checkoutLegalLastName?: string;
  checkoutLegalEmail?: string;
  oracleBillingCode?: string;
};

/** Banner 级拆分负载 */
export interface CostDistributionBannerPayload {
  bannerId: number | undefined;
  bannerName?: string;
  quantity: number | undefined;
  percent: number | undefined;
  amount: number | undefined;
}

/** Site/Cost Center 级拆分负载 */
export interface CostDistributionItemPayload {
  configId: number | undefined;
  siteName?: string;
  quantity: number | undefined;
  percent: number | undefined;
  amount: number | undefined;
  banner: string | undefined;
  banners: CostDistributionBannerPayload[];
  description?: string;
}

/** Category 级拆分负载 */
export interface CostDistributionCategoryPayload {
  categoryId: string | undefined;
  categoryName: string | undefined;
  jobId?: number; // Added jobId for per-job split
  subSplits: CostDistributionItemPayload[];
  quantity?: number;
  percent?: number;
  amount?: number;
}

/** Job 信息 */
export interface CostDistributionJobInfo {
  jobId: number;
  jobName: string;
  quantity: number | undefined;
  totalCharge: number | undefined;
}

/** 整体 Cost Distribution 负载结构 */
export interface CostDistributionPayload {
  categories: CostDistributionCategoryPayload[];

  // Manual Oracle billing line
  isManualOracleString: boolean;
  manualOracleString: string;
  oracleSettings?: CostDistributionOracleSettings[];

  // Job information
  jobs?: CostDistributionJobInfo[];
  isApplyToAllJobs: boolean;
  comments?: string;
  saveUserProfile?: boolean;
  updateContactOracleBillingCode?: boolean;
}

export interface CostDistributionOracleSettings {
  oracleString: string | undefined;
  amount: number | undefined;
  jobId: number | undefined;
  banner: string | undefined;
  site: string | undefined;
  siteDesc?: string;
  costCenter: string | undefined;
  costCenterDesc?: string;
  category: string | undefined;
  quantity: number | undefined;
  percent: number | undefined;
  description?: string;
}

export enum JobFlowEventEnum {
  addtocart = 'addtocart',
  submitorder = 'submitorder',
  poread = 'poread',
  poaccepted = 'poaccepted',
  podeclined = 'podeclined',
  proofapproved = 'proofapproved',
  proofdeclined = 'proofdeclined',
  proofrequestapproval = 'proofrequestapproval',
  submitartwork = 'submitartwork',
  trackingnumber = 'trackingnumber',
  shipdelibered = 'shipdelibered',
}

export type JobFlowPayload = {
  jobId: string | number;
  event: JobFlowEventEnum;
};

export type Order = {
  id: string | undefined;
  jobIds: number[];
  status: OrderStatusEnum | undefined;
  billingInfo: BillingInfo;
  billingRequestor: BillingRequestor;
  createAt: string;
  updateAt: string;
  freightCharge: number;
  printingCharge: number;
  taxCharge: number;
  totalCharge: number;
  requestor: ContactInfo;
  billingTo: ContactInfo;
};

export type BillingInfo = {
  accountingLine: string;
  billingContact: string;
  billtoCostCenter: string;
  purchaseOrder: string;
  sameAsRequestor: boolean;
};

export type BillingRequestor = {
  contactId: number;
  contactAddressId?: number;
  addressLine1: string;
  addressLine2: string;
  city: string;
  costCenter: string;
  country: string;
  department: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  postalCode: string;
  state: string;
  title: string;
  company: string;
};

export type ContactInfo = {
  contactId: number;
  contactAddressId: number;
  firstName: string;
  lastName: string;
  department: string;
  title: string;
  costCenter: string;
  addressLine1: string;
  addressLine2: string;
  phoneNumber: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
  company: string;
};

export type Billing = {
  billingInfo: BillingInfo;
  orderId: string;
  requestor: BillingRequestor;
};

export type BillingToInfo = {
  billingToContactId?: number;
  billingToAddressId?: number;
};

export enum PaymentTypeEnum {
  PO,
  STRIPE_CC,
  BALANCE,
}

export type OrderPayment = {
  eventTime: string;
  message: string;
  method: PaymentTypeEnum;
  success: boolean;
};

export enum OrderHistorySearchGroupEnum {
  MY_ORDERS = 'MY_ORDERS',
  ORGANIZATION_ORDERS = 'ORGANIZATION_ORDERS',
}

export type ShippingInfoAddress = {
  phoneNumber?: string;
  fromAddressLine?: string;
  fromCity?: string;
  fromCountryCode?: string;
  fromName?: string;
  fromPostalCode?: string;
  fromStateProvinceCode?: string;
  toAddressLine: string;
  toCity: string;
  toCompany?: string;
  toCountryCode: string;
  toName: string;
  toPostalCode: string;
  toStateProvinceCode: string;
  key: string;
  list?: PurchaseOrderJobShippingItem[];
  intersectionCarrierOptions?: PurchaseOrderJobShippingItemCarrierOptions[];
  intersectionAccountTypeOptions?: PurchaseOrderJobShippingItemAccountTypeOptions[];
};

export type BillingCategory = {
  id: string;
  category: string;
};

export type CostDistributionConfig = {
  id: number;
  categoryId: number;
  entity: string;
  lob: string;
  site: string;
  siteDesc: string;
  costCenter: string;
  costCenterDesc: string;
  product: string;
  account: string;
  description?: string;
  banner?: string;
};

export type JobCostDistributionBannerDTO = {
  id: number;
  banner: string;
  site: string;
  siteDescription: string;
};
